import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { Button, Layout, Menu, Avatar, Dropdown, Form, Input, InputNumber, Select, DatePicker, Card, Tabs, Upload, Modal, message, Table, Tag, Space, Popconfirm, Statistic, Typography, Switch, Alert } from 'ant-design-vue';
import * as Icons from '@ant-design/icons-vue';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import 'ant-design-vue/dist/reset.css';
import './assets/main.css';
import App from './App.vue';
import router from './router';

// Initialize dayjs with Chinese locale
dayjs.locale('zh-cn');

const app = createApp(App);
const pinia = createPinia();

// Register Ant Design Vue components
const components = [
  Button, Layout, Menu, Avatar, Dropdown, Form, Input, InputNumber, Select, DatePicker, 
  Card, Tabs, Upload, Modal, Table, Tag, Space, Popconfirm, Statistic, Typography, Switch, Alert
];

components.forEach(component => {
  app.use(component);
});

// Register Ant Design Vue icons
const icons = [
  'UserOutlined', 'LockOutlined', 'MailOutlined', 'ArrowLeftOutlined', 'PlusOutlined',
  'EditOutlined', 'DeleteOutlined', 'DownloadOutlined', 'CopyOutlined', 'UploadOutlined',
  'CheckOutlined', 'CloseOutlined', 'DashboardOutlined', 'AppstoreOutlined', 'TagsOutlined',
  'LogoutOutlined', 'SearchOutlined', 'ArrowUpOutlined', 'ArrowDownOutlined', 'DollarOutlined'
];

// 注册所有需要的图标
icons.forEach(icon => {
  app.component(icon, Icons[icon]);
});

// Configure message duration
message.config({
  maxCount: 3,
  duration: 3,
});

// Global properties
app.config.globalProperties.$message = message;
app.config.globalProperties.$dayjs = dayjs;

// Mount the app
app.use(pinia)
   .use(router)
   .mount('#app');
